import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IEpicsBuilder} from '@igp/shared/redux';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';

import {DebtTransferLogServiceTypes} from './constants';
import {DebtTransferLogDownloadClientStrategy, DebtTransferLogDownloadServerStrategy} from './downloadStrategy';
import {DebtTransferLogEpicsBuilder} from './epics';
import {DebtTransferLogService} from './service';
import type {DebtTransferLogEntityType, DebtTransferLogViewModelKeys} from './types';

export class DebtTransferLogContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<DebtTransferLogEntityType>>(DebtTransferLogServiceTypes.service).to(DebtTransferLogService);
        this._container
            .bind<IDownloadStrategy<DebtTransferLogViewModelKeys>>(DebtTransferLogServiceTypes.downloadClientStrategy)
            .to(DebtTransferLogDownloadClientStrategy);
        this._container
            .bind<IDownloadStrategy<DebtTransferLogViewModelKeys>>(DebtTransferLogServiceTypes.downloadServerStrategy)
            .to(DebtTransferLogDownloadServerStrategy);
        this._container.bind<IEpicsBuilder>(DebtTransferLogServiceTypes.epicsBuilder).to(DebtTransferLogEpicsBuilder);
    }
}
